import {
  Text,
  Checkbox,
  Spinner,
  VStack,
  HStack,
} from "@wootingkb/component-library";
import {
  discordNotificationTypeToNameMap,
  NotificationTypes,
} from "../../../utils/constants/discordNotificationTypes";
import { useDiscordUser } from "../../../utils/hooks/useDiscordUser";
import { useNotifications } from "./hooks/useNotifications";
import { useLingui } from "@lingui/react";
import { Trans } from "@lingui/react/macro";

export function Notifications() {
  const notifications = useNotifications();
  const { user } = useDiscordUser();
  const { _: i18n } = useLingui();

  if (!user) return <></>;

  return (
    notifications && (
      <VStack className="gap-2">
        <Text weight="semibold">
          <Trans id="Discord_notifications_title">Discord notifications</Trans>
        </Text>
        <VStack>
          {Object.values(NotificationTypes).map((key) => {
            const name =
              discordNotificationTypeToNameMap[key as NotificationTypes];

            return (
              <HStack key={key} className="items-center gap-2">
                <Checkbox
                  checked={user.notifications.includes(key)}
                  disabled={notifications.isLoading}
                  onCheckedChange={() => {
                    notifications.toggle(key as NotificationTypes);
                  }}
                />
                <Text>{i18n(name)}</Text>
                {notifications.isLoading && (
                  <Spinner size="xs" className="ml-2" />
                )}
              </HStack>
            );
          })}
        </VStack>
      </VStack>
    )
  );
}
